// F3a GREEN — taxId helpers (ported from deprecated-business@16fd6b71
// src/modules/onboarding/utils/taxId.ts, with formatTaxId added per the F3a
// contract).
//
// Contract:
//   compactTaxId(value)  -> strip whitespace + dashes, trim.
//   isTaxIdReady(value)  -> /^\d{9}$/ on the COMPACTED value (true only for
//                           exactly nine digits, in any formatting).
//   formatTaxId(value)   -> display helper: "12-3456789" once nine digits are
//                           present, otherwise the compacted partial value.

export const TAX_ID_HELPER_TEXT = "Use 9 digits, for example 12-3456789.";

export function compactTaxId(value: string): string {
  // Strip ASCII space, tab, and dash only — and ONLY those. JS String.trim()
  // and the \s class also match invisible unicode whitespace (BOM U+FEFF,
  // NBSP U+00A0, ideographic space U+3000, NNBSP U+202F). If those were
  // removed, a 9-digit value padded with an invisible char would pass the
  // readiness check. Removing only ASCII space/tab/dash leaves any unicode
  // whitespace in place so it breaks the 9-ASCII-digit shape and is rejected.
  // (fe-adversary P3.)
  return value.replace(/[ \t-]/g, "");
}

export function isTaxIdReady(value: string | null | undefined): boolean {
  return /^\d{9}$/.test(compactTaxId(value ?? ""));
}

export function formatTaxId(value: string): string {
  const compact = compactTaxId(value);
  if (/^\d{9}$/.test(compact)) {
    return `${compact.slice(0, 2)}-${compact.slice(2)}`;
  }
  return compact;
}
